<template>
  <div
    class="news-background section"
    :class="{ 'news-background--en': isEnLang, 'news-background--zh': !isEnLang }"
  >
    <div class="content-wrapper">
      <div class="content-bg">
        <header class="news-heading">
          <div>
            <span class="news-kicker">{{ isEnLang ? 'LATEST UPDATES' : '赛事动态' }}</span>
            <h2>{{ data[currentIdx].titleCh }}</h2>
          </div>
          <span class="news-en">{{ data[currentIdx].titleEn }}</span>
        </header>

        <div class="news-editorial" v-if="newsList.length > 0">
          <a :href="newsList[0].link" target="_blank" rel="noopener noreferrer" class="lead-story">
            <div class="news-card-meta">
              <span>FEATURED</span>
              <em>{{ categoryLabel(0) }}</em>
            </div>
            <h3>{{ newsList[0].text }}</h3>
            <div class="news-card-action">
              <span>{{ isEnLang ? 'READ STORY' : '阅读全文' }}</span>
              <i aria-hidden="true">↗</i>
            </div>
          </a>

          <div class="news-index">
            <a
              v-for="(item, index) in newsList.slice(1)"
              :key="item.id"
              :href="item.link"
              target="_blank"
              rel="noopener noreferrer"
              class="news-row"
            >
              <span>{{ String(index + 2).padStart(2, '0') }}</span>
              <em>{{ categoryLabel(index + 1) }}</em>
              <h3>{{ item.text }}</h3>
              <i aria-hidden="true">↗</i>
            </a>
          </div>
        </div>
        <div class="content-empty" v-else>
          <div class="empty-text">{{ isEnLang ? 'Updates will be published here.' : '暂无文章' }}</div>
        </div>
        <!-- <div class="tab-box" :class="`active_${currentIdx}`">
          <button
            @click="changeYear(0)"
            class="btn-tab"
            :class="{ active: currentIdx === 0 }"
          >
            2025
          </button>
          <button
            @click="changeYear(1)"
            class="btn-tab ml32"
            :class="{ active: currentIdx === 1 }"
          >
            2024
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import VueTypes from 'vue-types';

export default {
  components: {},
  props: {
    data: VueTypes.array.def([])
  },
  data() {
    return {
      currentIdx: 1  // 默认显示2024年数据
    };
  },
  computed: {
    ...mapState(['isMobile', 'isEnLang']),
    newsList () {
      return this.data[this.currentIdx] && this.data[this.currentIdx].content
        ? this.data[this.currentIdx].content.list
        : []
    }
  },
  methods: {
    categoryLabel (index) {
      const zh = ['赛事发布', '赛事动态', '行业观察', '技术公开课', '报名资讯', '往届回顾']
      const en = ['COMPETITION', 'INSIGHTS', 'MASTERCLASS', 'ANNOUNCEMENT', 'REGISTRATION', 'HIGHLIGHTS']
      return (this.isEnLang ? en : zh)[index] || (this.isEnLang ? 'NEWS' : '赛事资讯')
    }
    // changeYear(idx) {
    //   this.currentIdx = idx;
    // }
  }
};
</script>

<style lang="scss" scoped>
.ml32 {
  margin-left: 32px;
}
.news-background {
  padding-top: 60px;
  background: #f7f8fa;

  @include mobile {
    padding-top: 25px;
  }
}

.content-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tab-box {
  position: absolute;
  top: 46px;
  right: 38px;
  &::after {
    content: '';
    position: absolute;
    top: 45px;
    width: 56px;
    height: 4px;
    background-color: #fff;
    transition: all 0.15s ease-in-out;
  }
  &.active_0 {
    &::after {
      right: 88px;
    }
  }
  &.active_1 {
    &::after {
      right: 0px;
    }
  }
  .btn-tab {
    width: 56px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: transparent;
    border: none;
    color: #fff;
    font-size: 18px;
    font-weight: 300;
    cursor: pointer;
    font-family: 'Alibaba PuHuiTi 3.0';
    transition: all 0.15s ease-in-out;
    &.active {
      font-weight: bold;
    }
    &:hover {
      font-weight: bold;
    }
  }

  @include mobile {
    top: 14px;
    right: 22px;
  }
}

.content-bg {
  position: relative;
  width: 1200px;
  height: auto;
  padding: 42px;
  border: 1px solid #e2e7f0;
  border-radius: 18px;
  background: #f7f9fc;

  @include mobile {
    width: 100%;
    height: 100%;
    padding: 25px 22px 0 18px;
  }
}

.news-heading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 32px;
  padding-bottom: 40px;
  text-align: center;
  border-bottom: 0;
  position: relative;
}

.news-heading::after {
  content: '';
  position: absolute;
  bottom: 20px;
  width: 72px;
  height: 4px;
  border-radius: 99px;
  background: linear-gradient(90deg, #315fd8 0 58%, #dc3e73 58% 100%);
}

.news-kicker {
  display: none;
}

.news-heading h2 {
  color: #17233b;
  font-family: Alibaba-PuHuiTi-Heavy;
  font-size: 34px;
  line-height: 1.35;
}

.news-en {
  display: none;
}

.news-editorial {
  display: grid;
  grid-template-columns: minmax(0, .95fr) minmax(0, 1.55fr);
  gap: 38px;
  align-items: stretch;
}

.lead-story {
  position: relative;
  display: flex;
  min-height: 390px;
  padding: 32px;
  flex-direction: column;
  color: #fff;
  background: #173a96;
  overflow: hidden;
  transition: background .22s ease;

  &::after {
    content: '';
    position: absolute;
    right: -88px;
    bottom: -96px;
    width: 270px;
    height: 270px;
    border: 1px solid rgba(255,255,255,.16);
    border-radius: 50%;
    box-shadow: 0 0 0 34px rgba(255,255,255,.04), 0 0 0 68px rgba(255,255,255,.025);
  }

  &:hover {
    background: #2148ab;

    .news-card-action i { transform: translate(2px, -2px); }
  }

  h3 {
    max-width: 92%;
    margin-top: 52px;
    font-size: 25px;
    line-height: 1.5;
  }

  .news-card-meta,
  .news-card-action { color: rgba(255,255,255,.74); }
}

.news-card-meta,
.news-card-action {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #7c8799;
  font-size: 12px;
}

.news-card-meta span {
  font-family: DIN-BlackItalic, DIN;
  font-size: 14px;
}

.news-card-meta em {
  font-style: normal;
  font-weight: 600;
  letter-spacing: .08em;
}

.lead-story h3 {
  position: relative;
  z-index: 1;
  margin-top: 22px;
  font-size: 20px;
  font-weight: 650;
  line-height: 1.55;
}

.news-index {
  border-top: 2px solid #17233b;
}

.news-row {
  display: grid;
  /* Keep the category column wide enough for English labels so long
     headlines always start in their own column. */
  grid-template-columns: 36px minmax(138px, 178px) minmax(0, 1fr) 24px;
  align-items: center;
  column-gap: 16px;
  min-height: 78px;
  min-width: 0;
  border-bottom: 1px solid #d8dee8;
  color: #17233b;
  transition: color .18s ease, padding-left .18s ease;

  > span {
    color: #315fd8;
    font-family: DIN-BlackItalic, DIN;
    font-size: 14px;
  }

  > em {
    min-width: 0;
    color: #8a93a3;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: .05em;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  h3 {
    min-width: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.55;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  > i {
    color: #315fd8;
    font-size: 18px;
    font-style: normal;
  }

  &:hover {
    padding-left: 8px;
    color: #315fd8;
  }
}

/* Chinese headlines are denser than their English counterparts. Keep the
   English editorial rhythm intact while bringing the Chinese number/category
   columns closer to the headline for faster scanning. */
@media (min-width: 1121px) {
  .news-background--zh .news-row {
    grid-template-columns: 36px minmax(112px, 132px) minmax(0, 1fr) 24px;
    column-gap: 12px;
  }
}

.news-card-action {
  margin-top: auto;
  padding-top: 18px;
  color: #315fd8;
  font-weight: 600;
  letter-spacing: .08em;
}

.news-card-action i {
  font-size: 18px;
  font-style: normal;
  transition: transform .18s ease;
}

.title-text {
  position: absolute;
  left: 107px;
  top: 56px;
  font-size: 36px;
  font-family: Alibaba-PuHuiTi-Heavy;
  color: #ffffff;
  line-height: 25px;

  @include mobile {
    position: static;
    margin: 23px 0 0 0px;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 2px;
  }
}

@include mobile {
  .news-heading {
    align-items: center;
    margin-bottom: 16px;
  }

  .news-heading { margin-bottom: 24px; padding-bottom: 30px; }
  .news-heading::after { bottom: 10px; width: 48px; height: 3px; }
  .news-heading h2 { font-size: 24px; }
  .news-en { padding-top: 18px; }

  .news-editorial {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .lead-story {
    min-height: 230px;
    padding: 22px;

    h3 {
      margin-top: 30px;
      font-size: 20px;
    }
  }

  .news-row {
    grid-template-columns: 30px minmax(0, 1fr) 18px;
    gap: 10px;
    padding: 14px 0;

    > em { display: none; }
    h3 { font-size: 14px; }
    &:hover { padding-left: 0; }
  }
}

@media (min-width: 901px) and (max-width: 1120px) {
  .content-bg {
    width: calc(100vw - 40px);
    padding: 34px;
  }

  .news-editorial {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .lead-story {
    min-height: 280px;
    padding: 28px;

    h3 {
      max-width: 82%;
      font-size: 21px;
    }
  }

  .news-row {
    grid-template-columns: 34px minmax(112px, 140px) minmax(0, 1fr) 20px;
    column-gap: 12px;

    > em { letter-spacing: .02em; }
    h3 { font-size: 15px; }
  }
}

.content {
  display: flex;
  flex-wrap: wrap;
  column-gap: 60px;
  // height: 626px;
  height: 456px;
  width: 1120px;
  margin: 140px 40px 40px;
  padding: 18px 60px 40px;
  background: #ffffff;

  @include mobile {
    width: 100%;
    height: 100%;
    padding: 10px 19px 24px;
    margin: 18px 0 20px;
  }
}

.content-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 456px;
  width: 1120px;
  margin: 140px 40px 40px;
  padding: 18px 60px 40px;

  @include mobile {
    width: 100%;
    height: 100%;
    padding: 10px 19px 24px;
    margin: 18px 0 20px;
  }

  .empty-text {
    font-size: 18px;
    color: #ffffff;
    text-align: center;
  }
}

.content-list {
  width: 470px;
  border-bottom: 1px solid #000000;

  &:nth-child(2),
  &:nth-child(5),
  &:nth-child(9) {
    .text {
      height: auto;

      @include mobile {
        height: auto;
      }
    }
  }

  // &:nth-child(7),
  // &:nth-child(8) {
  //   .list-wrapper {

  //     @include mobile {
  //       padding-bottom: 0;
  //     }
  //   }
  // }

  &:nth-child(9),
  &:nth-child(10) {
    .list-wrapper {
      border-bottom: none;

      @include mobile {
        border-bottom: 1px solid #000000;
      }
    }
  }
}

.list-wrapper {
  display: flex;
  padding: 26px 0;

  @include mobile {
    position: relative;
    display: flex;
    height: auto;
    padding: 16px 0 16px 28px;
  }
}

.logo {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin: 5px 20px 0 0;

  @include mobile {
    position: absolute;
    left: 0;
    width: 19px;
    height: 36px;
    margin: 3px 9px 0 0;
  }
}

.text {
  color: #000000;
  font-size: 18px;
  font-weight: 400;
  line-height: 34px;
  vertical-align: super;

  &:hover {
    font-weight: 500;
  }

  @include mobile {
    font-size: 14px;
    line-height: 24px;
  }
}
</style>
